import React, { useState } from 'react'
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import axios from "../../API/axios";

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 250, background: '#000' }}>
            {props.reFresh ? <Box>
                <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: '#FFFFFF' }}
                    onClick={props.checkVideoStatus}
                >
                    Retry
                </Typography>
            </Box> : <Box>
                <CircularProgress variant="determinate" color="inherit" thickness={4} sx={{ color: '#FFFFFF' }} {...props} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: '#FFFFFF' }}
                    >
                        {`${Math.round(props.value)}%`}
                    </Typography>
                </Box>
            </Box>}

        </Box>
    );
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired,
};

const PostVideoCommon = ({ file, restrictedViewerToken, item }) => {
    const [progress, setProgress] = React.useState(parseInt(file?.videoIndexInsight?.processingProgress?.replace('%', ''), 10));
    const [apiCount, setApiCount] = useState(0)
    const [reFresh, setRefresh] = useState(false)

    // React.useEffect(() => {
    //     const percentage = parseInt(file?.videoIndexInsight?.processingProgress.replace('%', ''), 10);
    //     setProgress(percentage)
    // }, [])

    const checkVideoStatus = async () => {
        try {
            const reqData = {
                deviceType: "Web",
                postId: item?.postInfo?.postId,
                videoID: file?.mediaInfo,
                restrictedViewerToken: restrictedViewerToken
            }
            setRefresh(false)
            await axios.post(`Posts/GetVideoIndexInsight`, reqData).then((res) => {
                if (res?.data?.status === 'Success') {
                    setApiCount(apiCount + 1)
                    const percentage = parseInt(res?.data?.responseData?.processingProgress.replace('%', ''), 10);
                    console.log("percentage", percentage)
                    setProgress(percentage)
                } else {
                    setRefresh(true)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    React.useEffect(() => {
        console.log("progress", progress)
        console.log("progress", apiCount)
        if (progress !== 100) {
            checkVideoStatus()
        }
    }, [progress, apiCount]);

    console.log("file?.mediaInfo", item)
    return (
        <div className='videoPostContainer'>
            {progress < 100 ? <CircularProgressWithLabel value={progress} reFresh={reFresh} checkVideoStatus={checkVideoStatus} /> : <iframe width="100%" height="300" src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
            ></iframe>}
        </div>
    )
}

export default PostVideoCommon